import ActionTypes from '../actions/action-types';
import { UserConst } from 'redux/actions/user';

const INITIAL_STATE = {
  loader: false,
  options: {},
  header: {
    title: '',
  },
  user: {
    isLoggedIn: false,
    authError: false,
    options: {
      hasResume: false,
      hasCompliedGat: false,
      hasRecommendation: false,
    },
  },
};

export default function(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ActionTypes.SET_HEADER_TITLE:
      return {
        ...state,
        header: {
          title: action.payload,
        },
      };
    case ActionTypes.LOADER_SHOW:
      return {
        ...state,
        loader: true,
      };
    case ActionTypes.LOADER_HIDE:
      return {
        ...state,
        loader: false,
      };
    case UserConst.SIGN_IN.SUCCESS:
      const { status } = action.payload;
      return status === 'ERROR'
        ? { ...state, user: { ...state.user, authError: true } }
        : {
            ...state,
            user: {
              ...state.user,
              isLoggedIn: true,
              authError: false,
            },
          };
    case UserConst.SIGN_IN.FAILURE:
      return {
        ...state,
        user: {
          ...state.user,
          authError: true,
        },
      };

    case UserConst.GET.SUCCESS: {
      const { status, data } = action.payload;
      return {
        ...state,
        user: {
          ...state.user,
          ...data,
          authError: !status,
        },
      };
    }

    case UserConst.USER_UPDATE_OPTION.SUCCESS: {
      const { data } = action.payload;
      return {
        ...state,
        user: {
          ...state.user,
          options: {
            ...state.user.options,
            ...data,
          },
        },
      };
    }

    case UserConst.USER_UPDATE_PERMISSION.SUCCESS: {
      const { data } = action.payload;
      return {
        ...state,
        user: {
          ...state.user,
          permissions: {
            ...state.user.permissions,
            ...data,
          },
        },
      };
    }

    case UserConst.USER_SET_PERMISSION: {
      return {
        ...state,
        user: {
          ...state.user,
          permission: {
            ...state.user.permission,
            ...action.payload,
          },
        },
      };
    }

    case UserConst.USER_SET_OPTION: {
      return {
        ...state,
        user: {
          ...state.user,
          options: {
            ...state.user.options,
            ...action.payload,
          },
        },
      };
    }

    case UserConst.USER_UPDATE_RESUME: {
      return {
        ...state,
        user: {
          ...state.user,
          options: {
            ...state.user.options,
            hasResume: true,
          },
        },
      };
    }

    case UserConst.USER_UPDATE_PICTURE: {
      return {
        ...state,
        user: {
          ...state.user,
          avatar: action.payload,
        },
      };
    }

    case UserConst.USER_UPDATE_POPUPS: {
      return {
        ...state,
        user: {
          ...state.user,
          popups: { ...action.payload },
        },
      };
    }

    case UserConst.USER_UPDATE_INBOX_COUNT: {
      return {
        ...state,
        user: {
          ...state.user,
          counters: {
            ...state.user.counters,
            inbox: action.payload,
          },
        },
      };
    }

    case UserConst.USER_UPDATE_INBOUNDS_COUNT: {
      return {
        ...state,
        user: {
          ...state.user,
          inbounds: action.payload,
        },
      };
    }

    case UserConst.GET.FAILURE: {
      return {
        ...state,
        user: {
          ...state.user,
          authError: true,
        },
      };
    }

    case `${ActionTypes.GET_OPTIONS}_SUCCESS`: {
      return {
        ...state,
        options: { ...action.payload.data },
      };
    }

    default:
      return state;
  }
}
